import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useOffice } from "../../../../hooks/useOffice";
import { useCash } from "../../../../hooks/useCash";
import { RiHomeOfficeFill } from "react-icons/ri";
import Spinner from "../../../../components/Spinner";
import { FaPlus } from "react-icons/fa";
import SearchFilters from "../../../../components/SearchFilters";
import { IoFilter } from "react-icons/io5";
import OfficeDetails from "../../../../components/ui/OfficeDetails";
import { getProvinceName } from "../../../../utils/Common";
import Swal from "sweetalert2";
import NotifyC from "../../../../components/Notifications"
import "./index.css";

const PostOffices = () => {
  const { getAllPostOffices,  updatePostOffice,  getListProvinces } = useOffice();
  const { getCashBoxStatus, createCashBox, updateCashBox } = useCash();
  const [offices, setOffices] = useState([]);
  const [filteredOffices, setFilteredOffices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [openSearch, setOpenSearch] = useState(false);
  const [configFilter, setConfigFilter] = useState({totalItems: 0,totalPages: 1,itemsPerPage: 8, currentPage: 1,});
  const [selectedOffice, setSelectedOffice] = useState(null); 
  const history = useHistory();
  const [provinces, setProvinceList] = useState([]);

  const parametersSearch = [
    { id: "NombreProvincia", label: "Provincia" },
    { id: "NombreSucursal", label: "Nombre" },
    { id: "Codigo", label: "Código" },
    { id: "Direccion", label: "Dirección" },
    { id: "Telefono", label: "Teléfono" },
  ];

  const handleGetOfficeByProvince = async () => {
    const abortController = new AbortController();
    try {
        const response = await getListProvinces(abortController.signal);
        if (response.length > 0) {
            setProvinceList(response);
        } else {
            setProvinceList([]);
            NotifyC.error('No se encontraron estafetas por asignar en la provincia seleccionada al usuario');
        }
    } catch (error) {
        NotifyC.error('Error al obtener la lista de provincias');
    }
};

  const handleGetPostOffices = async () => {
      const abortController = new AbortController();
      try {
        const response = await getAllPostOffices(abortController.signal);
        const responseCash = await getCashBoxStatus(abortController.signal);
        
        if (!response?.length) {
          NotifyC.error("No se encontraron datos de estafetas.");
          setOffices([]);
          setFilteredOffices([]);
          setConfigFilter((prev) => ({
            ...prev,
            totalItems: 0,
            totalPages: 1,
          }));
          return;
        }
  
        const officesWithCashBoxes = response.map((office) => {
          const cashBoxes = responseCash?.cajas?.filter(
            (cashBox) => cashBox.IdSucursal === office.IdSucursal
          ) || [];
          return { ...office, cashBoxes };
        });
        setOffices(officesWithCashBoxes);
        setFilteredOffices(officesWithCashBoxes);
        setConfigFilter((prev) => ({
          ...prev,
          totalItems: officesWithCashBoxes.length,
          totalPages: Math.ceil(officesWithCashBoxes.length / prev.itemsPerPage),
        }));
      } catch (error) {
        console.error("Error fetching offices and cash boxes:", error);
      } finally {
        setIsLoading(false);
      }
    };

  useEffect(() => {
    let filtered = offices;
    selectedFilters.forEach((filter) => { filtered = filtered.filter((office) => office[filter.id]?.toLowerCase().includes(filter.searchTerm.toLowerCase())
      );
    });
    setFilteredOffices(filtered);
    setConfigFilter((prev) => ({...prev, totalItems: filtered.length, totalPages: Math.ceil(filtered.length / prev.itemsPerPage), currentPage: 1,
    }));
  }, [selectedFilters, offices]);

  const goToPage = (page) => {
    setConfigFilter((prev) => ({...prev, currentPage: page,
    }));
  };

  const indexOfLastOffice = configFilter.currentPage * configFilter.itemsPerPage;
  const indexOfFirstOffice = indexOfLastOffice - configFilter.itemsPerPage;
  const currentOffices = filteredOffices.slice(indexOfFirstOffice, indexOfLastOffice);

  const handleResetFilters = () => { setSelectedFilters([]); handleViewSearch();};

  const handleViewSearch = () => { setOpenSearch(!openSearch); };

  useEffect(() => { handleGetPostOffices()}, []);

  useEffect(() => { handleGetOfficeByProvince()}, []);

  const handleOfficeClick = (office) => { setSelectedOffice(office);};

  const handleCloseDetails = () => { setSelectedOffice(null);
  };

  const LoadingSpinner = () => (
    <div
      style={{
        position: "absolute",
        top: 0,
        padding: 20,
        right: 0,
        left: 0,
        backgroundColor: "rgb(0 0 0 / 81%)",
        height: "100vh",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "black",
      }}
      className="text-left"
    >
      <Spinner type={1} size={40} color="white" />
    </div>
  );

  const showConfirmationDialog = async (title, html) => {
    return await Swal.fire({
      icon: "question",
      title: title,
      html: html,
      showCancelButton: true,
      confirmButtonColor: "white",
      cancelButtonColor: "black",
      confirmButtonText: "Si",
      cancelButtonText: "No",
      customClass: {
        confirmButton: 'custom-confirm-button',
        cancelButton: 'custom-cancel-button',
      }
    });
  };

  const handleErrorResponse = (response) => {
    if (response.code === 400) {
      switch (response.message) {
        case "OFFICE_ALREADY_DEACTIVATED":
          NotifyC.error("La estafeta ya se encuentra desactivada.");
          break;
        case "OFFICE_ALREADY_ACTIVATED":
          NotifyC.error("La estafeta ya se encuentra activada.");
          break;
        case "NO_CHANGES_MADE":
          NotifyC.error("No se realizaron cambios.");
          break;
        case "CASHBOX_NOT_DELETED":
          NotifyC.error("No se puede eliminar la caja.");
          break;
        case "CANNOT_DELETE_CASHBOX_HAS_MOVEMENTS":
          NotifyC.error("No se puede eliminar la caja porque tiene movimientos.");
          break;
        case "DUPLICATE_CODE_OR_NAME":
          NotifyC.error("Ya existe una estafeta con ese nombre o código.");
          break;
        case "CASHBOX_ALREADY_INACTIVE":
          NotifyC.error("La caja ya se encuentra desactivada.");
          break;
        case "CASHBOX_ALREADY_ACTIVE":
          NotifyC.error("La caja ya se encuentra activada.");
          break;
        default:
          NotifyC.error("Error al actualizar.");
          break;
      }
    }
  };

  const refreshAndUpdateSelectedOffice = async (officeId) => {
    try {
      await handleGetPostOffices();
      
      const updatedOffices = await getAllPostOffices(new AbortController().signal);
      const updatedCashBoxes = await getCashBoxStatus(new AbortController().signal);
      
      if (updatedOffices?.length && updatedCashBoxes?.cajas) {
        const officeWithUpdatedCashBoxes = updatedOffices.find(
          (office) => office.IdSucursal === officeId
        );
        
        if (officeWithUpdatedCashBoxes) {
          const cashBoxes = updatedCashBoxes.cajas.filter(
            (cashBox) => cashBox.IdSucursal === officeWithUpdatedCashBoxes.IdSucursal
          );
          const updatedOffice = { ...officeWithUpdatedCashBoxes, cashBoxes };
          setSelectedOffice(updatedOffice);
        }
      }
    } catch (error) {
      console.error("Error al refrescar la oficina seleccionada:", error);
    }
  };
  
  const handleAddCaja = async (nombreCaja) => {
    const confirm = await showConfirmationDialog(
      `¿Deseas crear una caja con el nombre "${nombreCaja}"?`,
      ""
    );
  
    if (confirm.isConfirmed) {
      try {
        const abortController = new AbortController();
  
        const dataToSend = {
          IdPostOffice: selectedOffice.IdSucursal,
          name: nombreCaja
        };
        const response = await createCashBox(abortController.signal, dataToSend);
  
        if (response.code === 200) {
          await refreshAndUpdateSelectedOffice(selectedOffice.IdSucursal);
          
          Swal.fire({
            icon: "success",
            title: "Caja creada",
            html: `La caja se ha creado exitosamente para la sucursal ${selectedOffice.NombreSucursal}.`,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "custom-confirm-button",
            },
          });
        }
      } catch (error) {
        NotifyC.error("Error al crear la caja.");
      }
    }
  };
  
  const handleStatusOffice = async (office, newStatus) => {
    const status = newStatus === true ? "activar" : "desactivar";
    const confirm = await showConfirmationDialog(
      `¿Deseas ${status} la estafeta "${office.NombreSucursal}"?`,
      ""
    );
  
    if (!confirm.isConfirmed) return;
  
    try {
      const abortController = new AbortController();
  
      const dataToSend = {
        Accion: newStatus === true ? 3 : 2,
        IdPostOffice: office.IdSucursal,
        IdProvincia: office.IdProvincia
      };
  
      const response = await updatePostOffice(abortController.signal, dataToSend);
  
      if (response.code === 200) {
        if (selectedOffice && selectedOffice.IdSucursal === office.IdSucursal) {
          await refreshAndUpdateSelectedOffice(office.IdSucursal);
        } else {
          await handleGetPostOffices();
        }
        
        Swal.fire({
          icon: "success",
          title: "Estado de la estafeta actualizada",
          html: `La estafeta ${office.NombreSucursal} ha sido ${dataToSend.Accion === 2 ? "desactivada" : "activada"}.`,
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "custom-confirm-button",
          },
        });
      } else {
        handleErrorResponse(response);
      }
      return response;
    } catch (error) {
      NotifyC.error("Error al actualizar la estafeta.");
    }
  };

  const handleStatusCaja = async (cashBox, newStatus) => {
    const status = newStatus === 3 ? "activar" : "desactivar";
    const confirm = await showConfirmationDialog(
      `¿Deseas ${status} la caja "${cashBox.NombreCaja}"?`,
      ""
    );

    if (!confirm.isConfirmed) return;

    try {
      const abortController = new AbortController();

      const dataToSend = {
        Accion: newStatus === 2 ? 2 : 3,
        IdCashBox: cashBox.IdCaja,
        IdPostOffice: cashBox.IdSucursal
      };

      const response = await updateCashBox(abortController.signal, dataToSend);

      if (response.code === 200) {
        await refreshAndUpdateSelectedOffice(selectedOffice.IdSucursal);
        
        Swal.fire({
          icon: "success",
          title: "Estado de la caja actualizada",
          html: `La caja ${cashBox.NombreCaja} ha sido ${dataToSend.Accion === 2 ? "desactivada" : "activada"}.`,
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "custom-confirm-button",
          },
        });
      } else {
        handleErrorResponse(response);
      }
      return response;
    } catch (error) {
      NotifyC.error("Error al actualizar la caja.");
    }
  };
  
  const handleOnUpdateCaja = async (EditCaja, cashBox) => {
    const confirm = await showConfirmationDialog(
      `Actualizar`,
      `¿Deseas la caja seleccionada?`
    );
  
    if (!confirm.isConfirmed) return;
  
    try {
      const abortController = new AbortController();
  
      const dataToSend = {
        Accion: 1,
        IdCashBox: EditCaja.IdCaja,
        Name: EditCaja.NombreCaja,
        IdPostOffice: EditCaja.IdSucursal
      };
  
      const response = await updateCashBox(abortController.signal, dataToSend);
      if (response.code === 200) {
        await refreshAndUpdateSelectedOffice(selectedOffice.IdSucursal);
        
        NotifyC.success(`La caja se ha actualizado exitosamente.`);
        return response;
      } else {
        handleErrorResponse(response);
      }
      
    } catch (error) {
      NotifyC.error("Error al actualizar la caja.");
    }
  };

  const handleOnUpdateOffice = async (office, IdProvince) => {
    try {
      const abortController = new AbortController();

      const dataToSend = {
        Accion: 1,
        IdPostOffice: office.IdSucursal,
        Nombre: office.NombreSucursal,
        Codigo: office.Codigo,
        Direccion: office.Direccion,
        Telefono: office.Telefono,
        IdEstatus: office.IdEstatus,
        IdProvincia: IdProvince,
      };

      const response = await updatePostOffice(abortController.signal, dataToSend);
      
      if (response.code === 200) {
        await refreshAndUpdateSelectedOffice(office.IdSucursal);
        
        NotifyC.success(`La estafeta ${office.NombreSucursal} se ha actualizado exitosamente.`);
       }
       else{
        handleErrorResponse(response);
       }
    } catch (error) {
      NotifyC.error("Error al actualizar la estafeta.");
    }
  };

  return (
    <>
      {/* Mostrar detalles de la estafeta seleccionada */}
      {selectedOffice ? (
        <OfficeDetails
          office={selectedOffice}
          onClose={handleCloseDetails}
          onAddCaja={handleAddCaja}
          onUpdateOffice={handleOnUpdateOffice}
          onStatusOffice={handleStatusOffice}
          onStatusCaja={handleStatusCaja}
          onUpdateCaja={handleOnUpdateCaja}
          isActive={selectedOffice.IdEstatus === 1 ? true : false}
          provinces={provinces}
       />
      ) : (
        <>
          <div className="dashboardCard text-left" style={{ color: "black" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
              <div className="d-flex align-items-center" style={{ gap: "15px", flex: "1" }}>
                <RiHomeOfficeFill size={20} className="mr-1" />
                <h5 className="mb-0">Estafetas</h5>
              </div>
              <button className="btn btn-warning mr-2" style={{color:"black"}} onClick={() => history.push("/dashboard/administration/create/postoffice")}>
                <FaPlus /> Crear Estafeta
              </button>
              <div className="d-flex align-items-center" style={{ gap: "15px", flex: "0" }}>
                <div className="d-flex">
                  {/* Botón de Filtros */}
                  <button className="btn btn-white d-flex align-items-center" onClick={() => handleViewSearch()}>
                    {selectedFilters.length > 0 && (
                      <span className="badge mr-1" style={{ background: "#424996", color: "white" }}>
                        {selectedFilters.length}
                      </span>
                    )}
                    <span>Filtros</span>
                    <IoFilter className="ml-2" />
                  </button>

                  {/* Panel de Filtros */}
                  {openSearch && (
                    <div style={{ position: "absolute", right: "15px", top: "110px", background: "#fff", padding: "25px", boxShadow: "0px 0px 10px rgba(92, 92, 92, 0.211)", borderRadius: "16px", zIndex: 99 }}>
                      <button
                        type="button"
                        className="btn btn-sm"
                        style={{ position: "absolute", top: "-5px", right: "0", color: "white", background: "gray", padding: "0 5px", borderRadius: "50px" }}
                        onClick={() => handleViewSearch()}
                      >
                        &times;
                      </button>
                      <SearchFilters
                        parameters={parametersSearch}
                        selectedFilters={selectedFilters}
                        setSelectedFilters={setSelectedFilters}
                        handleResetFilters={handleResetFilters}
                      />
                    </div>
                  )}
                </div>

                {/* Botones de Paginación */}
                <div className="d-flex align-items-center ml-2">
                  <button
                    className="btn btn-white mr-2"
                    onClick={() => goToPage(configFilter.currentPage - 1)}
                    disabled={configFilter.currentPage === 1}
                  >
                    {"<"}
                  </button>
                  <div className="d-flex align-items-center">
                    <span>{configFilter.currentPage}</span>
                    <span className="mx-1">de</span>
                    <span>{configFilter.totalPages}</span>
                  </div>
                  <button
                    className="btn btn-white ml-2"
                    onClick={() => goToPage(configFilter.currentPage + 1)}
                    disabled={configFilter.currentPage === configFilter.totalPages}
                  >
                    {">"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {!isLoading ? (
            <div className="dashboardCard">
              <div className="container-post-offices">
                {/* Lista de estafetas */}
                <div className="offices-list">
                  {currentOffices.length > 0 ? (
                    currentOffices.map((office, index) => (
                      <div key={office.idSucursal || `office-${index}`} className="office-card" onClick={() => handleOfficeClick(office)}>
                      <div
                        className="office-image-container"
                        style={{
                          backgroundImage: "url('../../img/design-correso-login.png')", 
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      >
                        <img src="../../img/pa_flag.png" alt="Office" className="office-image" />
                      </div>
                      
                      <div className="office-info">
                        <h3 className="office-name"><RiHomeOfficeFill /> {" "}{office.NombreSucursal}</h3>
                        
                        <div className="office-details">
                        <div className="detail-item">
                            <span className="detail-icon"><i className="fas fa-barcode"></i></span>
                            <span className="detail-label">Provincia:</span>
                            <span className="detail-value">{getProvinceName(office.IdProvincia)}</span>
                          </div>

                          <div className="detail-item">
                            <span className="detail-icon"><i className="fas fa-barcode"></i></span>
                            <span className="detail-label">Código:</span>
                            <span className="detail-value">{office.Codigo}</span>
                          </div>
                          
                          <div className="detail-item">
                            <span className="detail-icon"><i className="fas fa-box"></i></span>
                            <span className="detail-label">Estado:</span>
                            <span className={`office-status ${office.IdEstatus === 1 ? 'active' : 'inactive'}`}>
                              {office.IdEstatus === 1 ? 'Activa' : 'Inactiva'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    ))
                  ) : (
                    <Spinner type={1} size={40} color="black" />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <LoadingSpinner />
          )}
        </>
      )}
    </>
  );
};

export default PostOffices;